import type {GuideMenuItem} from "@ips/ui-kit";

export const guideAudioItems:ReadonlyArray<GuideMenuItem>=[
  {label:"Panoramica di Plant Manager",href:"/guide-audio/01-panoramica-plant-manager.mp3"},
  {label:"Registro Asset e struttura dell'impianto",href:"/guide-audio/02-registro-asset.mp3"},
  {label:"Dal Registro Asset alla Manutenzione",href:"/guide-audio/03-asset-e-manutenzione.mp3"},
  {label:"Workflow della Manutenzione",href:"/guide-audio/04-workflow-manutenzione.mp3"},
  {label:"Esecuzioni, Registro e Anomalie",href:"/guide-audio/05-esecuzioni-registro-anomalie.mp3"},
  {label:"Workflow della gestione documentale",href:"/guide-audio/06-workflow-documenti.mp3"},
  {label:"Revisioni e controllo documentale",href:"/guide-audio/07-controllo-documentale.mp3"},
  {label:"Workflow dei Permessi di lavoro",href:"/guide-audio/08-workflow-permessi.mp3"},
  {label:"Moduli specialistici e Dashboard",href:"/guide-audio/09-moduli-specialistici.mp3"},
  {label:"Aiuto intelligente e validazione umana",href:"/guide-audio/10-aiuto-intelligente.mp3"},
];
